<div class="bp-modal mod-lg">
	<bp-modal-header [title]="'aml5_modal_header' | translate"></bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section pt-10">
			<div class="aml-modal-wrapper spacer-4">
				<h1 class="font-size-32 font-bold text-center spacer-4">{{ "aml5_modal_title" | translate }}</h1>
				<p class="text-center spacer-4">{{ "aml5_modal_teaser" | translate }}</p>
				<div class="aml-info-box">
					<div class="aml-info-icon">
						<img [src]="'/assets/images/shield.svg'" [alt]="'aml5_modal_data_info_title' | translate" />
					</div>
					<div class="aml-info-text">
						<p class="font-bold mb-0">{{ "aml5_modal_data_info_title" | translate }}</p>
						<p class="text-light font-size-13">{{ "aml5_modal_data_info_teaser" | translate }}</p>
					</div>
				</div>
			</div>
			<a (click)="onContinueClicked()" class="btn btn-primary btn-bold btn-block" type="button">
				{{ "aml5_modal_continue_button" | translate }}
			</a>
		</div>
	</div>
</div>
